module.exports = __webpack_public_path__ + "static/Soccer-07a1779f9a90ba6ddd61906826c88497.mp4";